import { DOCS_URL } from "../../../config/constants.js";
import ServiceCalloutContainer from "./ServiceCalloutContainer.svelte";

export default {
    component: ServiceCalloutContainer,
    name: "Service Callout Container",
    description: "Labelled service page container for related work, quote and result cards",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-servicecalloutcontainer--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/cards.svg",
    models: ["service-page"],
    canHaveChildren: true,
    defaultChildren: [
        {
            "@type": "@builder.io/sdk:Element",
            component: {
                name: "Service Related Work Card",
                options: { title: "Related work" },
            },
        },
    ],
    inputs: [
        {
            friendlyName: "Label",
            name: "label",
            type: "string",
            defaultValue: "Related Work",
        },
    ],
    childRequirements: {
        message: "Use service page callout card components here",
        query: {
            "component.name": {
                $in: ["Service Related Work Card", "Service Quote Card", "Service Result Card"],
            },
        },
    },
};
